import { BigNumber, BigNumberish } from "ethers";
import { formatEther } from "ethers/lib/utils";
import { useMemo } from "react";
import { FancyBearLevelDetails } from "types";
import {
  calculateHoneyConsumptionRequirement,
  calculateLevel,
} from "utils/levelUtils";

const useBearLevelDetails = (
  honey?: BigNumberish
): FancyBearLevelDetails | undefined =>
  useMemo(() => {
    if (!honey) {
      return;
    }

    const honeyConsumed = BigNumber.from(honey);

    const currentLevel = calculateLevel(honeyConsumed);
    const nextLevel = currentLevel + 1;

    const currentLevelHoneyRequirement =
      calculateHoneyConsumptionRequirement(currentLevel);
    const nextLevelHoneyRequirement =
      calculateHoneyConsumptionRequirement(nextLevel);

    const honeyAmountToReachNextLevel =
      nextLevelHoneyRequirement.sub(honeyConsumed);

    const honeyDifferenceBetweenCurrentAndNextLevel =
      nextLevelHoneyRequirement.sub(currentLevelHoneyRequirement);

    const nextLevelProgress = Math.round(
      (parseInt(
        formatEther(honeyConsumed.sub(currentLevelHoneyRequirement)),
        10
      ) /
        parseInt(
          formatEther(
            nextLevelHoneyRequirement.sub(currentLevelHoneyRequirement)
          ),
          10
        )) *
        100
    );

    return {
      currentLevel,
      nextLevel,
      honeyConsumed,
      nextLevelHoneyRequirement,
      currentLevelHoneyRequirement,
      honeyAmountToReachNextLevel,
      honeyDifferenceBetweenCurrentAndNextLevel,
      nextLevelProgress,
    };
  }, [honey]);

export default useBearLevelDetails;
